/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Calendar, Badge, Skeleton, Empty, Popconfirm, message } from 'antd'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import '../index.scss'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'

import AddForm from './addForm'
import ViewDetails from './view'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			isAddFormShown: false,
			isViewReservationShown: false,
			selectedDate: null,
			selectedReservation: null,
			isReloadCalender: false
		}
        
		this.dateCellRender = this.dateCellRender.bind(this)
		this.monthCellRender = this.monthCellRender.bind(this)
		this.onCellDateSelect = this.onCellDateSelect.bind(this)
		this.disabledDate = this.disabledDate.bind(this)
	}
    
	disabledDate (value) {
		return value < moment(new Date(), 'YYYY-MM-DD').subtract(1, 'day')
		// return value < moment(new Date(), 'YYYY-MM-DD')
	}
    
	dateCellRender(value) {
		// console.log('value dateCellRender', value)
		const { AuthStore } = this.props
		const { barangay_uid } = AuthStore
		return (
			<Query 
				query={RESERVATION_BY_DATE} 
				variables={{ barangay_uid, reservation_date: moment(value).format('YYYY-MM-DD') }}
				fetchPolicy='network-only'
			>
				{({ loading, error, data }) => {
					if (loading) return <Skeleton active/>
					if (error) return <Empty/>

					let mReservations = _.has(data,'reservationByDate') ? data.reservationByDate : []
					//console.log('mEvents', mEvents)
					if (mReservations && (mReservations.length > 0)) {
						return (
							<React.Fragment>
								{
									(value > moment(new Date(), 'YYYY-MM-DD').subtract(1, 'day')) &&
									<Row>
										<a 
											href='javascript:void(0)'
											style={{ fontSize: 11 }}
											onClick={() => this.onCellDateSelect(value)}
										><i className='fe-plus'></i> New Reservation</a>
									</Row>
								}
								<Row>
									<ul className="events">
										{mReservations.map(item => (
											<Popconfirm
												key={item.uid}
												title="View / Edit"
												onConfirm={() => {
													this.setState({ isViewReservationShown: true, selectedReservation: item })
												}}
												onCancel={() => {
													if (value > moment(new Date(), 'YYYY-MM-DD').subtract(1, 'day')) {
														this.setState({ isAddFormShown: true, selectedReservation: item })
													} else {
														message.error('You cannot edit past date reservation.')
													}
												}}
												okText="View"
												cancelText="Edit"
											>
												<li>
													<Badge status='warning' text={item.name} />
												</li>
											</Popconfirm>
										))}
									</ul>
								</Row>
							</React.Fragment>
						)
					} else {
						if (value > moment(new Date(), 'YYYY-MM-DD').subtract(1, 'day')) {
							return (
								<a 
									href='javascript:void(0)'
									style={{ fontSize: 11 }}
									onClick={() => this.onCellDateSelect(value)}
								><i className='fe-plus'></i> New Reservation</a>
							)
						}
						return null
					}
				}}
			</Query>
		)
	}
    
	monthCellRender(value) {
		console.log('value monthCellRender', moment(value).format('YYYY-MM'))
	}
    
	onCellDateSelect(value) {
		// console.log('value onCellDateSelect', value)
		this.setState({ isAddFormShown: true, selectedDate: moment(value).format('YYYY-MM-DD') })
	}

	render() {
		const { isReloadCalender, isAddFormShown, isViewReservationShown, selectedDate, selectedReservation } = this.state
		return (
			<React.Fragment>
				<div className="row">
					<div className="col-12">
						<div className="page-title-box">
							<div className="page-title-right">
								<ol className="breadcrumb m-0">
									<li className="breadcrumb-item"><Link to='/'>Dashboard</Link></li>
									<li className="breadcrumb-item"><a href='javascript:void(0)'>Barangay Management</a></li>
									<li className="breadcrumb-item active">Facilities Reservation</li>
								</ol>
							</div>
							<h4 className="page-title">Facilities Reservation</h4>
						</div>
					</div>
				</div>
				<div className="row" style={{ minHeight: '600px' }}>
					<div className="col-12">
						<div className='card'>
							<div className='card-body'>
								{
									!isReloadCalender &&
                                    <Calendar 
                                    	disabledDate={this.disabledDate}
                                    	dateCellRender={this.dateCellRender} 
                                    	monthCellRender={this.monthCellRender}
                                    	// onSelect={this.onCellDateSelect}
                                    />
								}
							</div>
						</div>
					</div>
				</div>
				{
					isAddFormShown &&
                    <AddForm
                    	selectedReservation={selectedReservation}
                    	selectedDate={selectedDate}
                    	visible={isAddFormShown}
                    	onClose={() => this.setState({ isAddFormShown: false, selectedReservation: null, isReloadCalender: true }, () => {
                    		this.setState({ isReloadCalender: false })
                    	})}
                    />
				}
				{
					isViewReservationShown &&
					<ViewDetails 
						reservation={selectedReservation}
						visible={isViewReservationShown}
						onCancel={() => this.setState({ isViewReservationShown: false, selectedReservation: null, isReloadCalender: true }, () => {
							this.setState({ isReloadCalender: false })
						})}
					/>
				}
			</React.Fragment>
		)
	}
}

const RESERVATION_BY_DATE = gql`
    query reservationByDate($barangay_uid: String, $reservation_date: String) {
		reservationByDate(barangay_uid: $barangay_uid, reservation_date: $reservation_date)
    }
`

const composed = compose(
	inject('AuthStore'),
	observer
)

export default composed(Index)
